import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Col } from 'reactstrap';
import { FormValues } from '../UserInvitationPage';
import { InputFormField } from '../../../components/InputFormField';

interface PropTypes {
  register: UseFormRegister<FormValues>;
  invalidInput: boolean;
  passwordFieldName?: string;
  confirmPasswordFieldName?: string;
  passwordPlaceholder?: string;
  passwordConfirmationPlaceholder?: string;
}

export function PasswordRow(props: PropTypes) {
  return (
    <>
      <div className='row mb-3'>
        <Col sm={12}>
          <InputFormField
            type={'password'}
            registerReturn={props.register('password', {
              required: true,
            })}
            fieldName={
              props.passwordFieldName ? props.passwordFieldName : 'Password'
            }
            placeholder={
              props.passwordPlaceholder
                ? props.passwordPlaceholder
                : 'Insert Password'
            }
            isRequired={true}
            invalidInput={props.invalidInput}
          />
        </Col>
      </div>
      <div className='row mb-3'>
        <Col sm={12}>
          <InputFormField
            type={'password'}
            registerReturn={props.register('passwordConfirmation', {
              required: true,
            })}
            fieldName={
              props.confirmPasswordFieldName
                ? props.confirmPasswordFieldName
                : 'Confirm Password'
            }
            placeholder={
              props.passwordConfirmationPlaceholder
                ? props.passwordConfirmationPlaceholder
                : 'Confirm Password'
            }
            isRequired={true}
            invalidInput={props.invalidInput}
          />
        </Col>
      </div>
    </>
  );
}
